import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SasMarkOnSubmitDirective, SasSelectEmptyValueDirective, SasTruncateSelectOptionsDirective } from '@directives';
import { SasFormControlBase } from '../sas-forms/sas-form-control.base';

@Component({
    selector: 'sas-select',
    standalone: true,
    imports: [FormsModule, TranslateModule, SasMarkOnSubmitDirective, SasSelectEmptyValueDirective, SasTruncateSelectOptionsDirective],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SasSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SasSelectComponent),
            multi: true
        }
    ],
    templateUrl: './sas-select.component.html',
    styleUrl: './sas-select.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SasSelectComponent extends SasFormControlBase {
    @Input() sasDisabled = false;
    @Input() sasOptions: { id: any; name: string }[] = [];
    // booleanAttribute transform accepts 'true'/'false' strings from attribute bindings
    @Input({ transform: booleanAttribute }) customSort = false;
    @Output() sasOnSelect = new EventEmitter<any>();

    items: { id: unknown; name: string }[] = [];

    override ngOnChanges(changes: Record<string, { currentValue: unknown }>): void {
        super.ngOnChanges(changes);
        if (changes['sasOptions']) {
            this.items = this.sortItems();
        }
        if (changes['sasDisabled']) {
            this.sasReadonly = this.sasDisabled;
        }
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.sasDisabled) {
            this.sasReadonly = true;
        }
        if (!this.items.length) {
            this.items = this.sortItems();
        }
    }

    get hasVisibleError(): boolean {
        const control = this.element;

        return !!control?.invalid && (!!control.dirty || !!control.touched);
    }

    onSelectChange(value: unknown): void {
        this.onValueChange(value);
        this.sasOnSelect.emit({ value, selectId: this.sasId, selectName: this.name });
    }

    private sortItems(): { id: unknown; name: string }[] {
        const options = [...(this.sasOptions ?? [])];

        return this.customSort
            ? options
            : options.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? '', 'en', { numeric: true }));
    }
}
